import React from 'react';
import {gmslar} from "../../../../../../../../components/sfr/maydon";
import {foiz} from "../../../../../../../../components/functions/Mathematik";

function Info(props) {
    const season = localStorage.getItem('sfr-hm-season')
    const crops1 = localStorage.getItem('sfr-hm-'+season+'-ekinids')
    const cropids = crops1?JSON.parse(crops1):{}
    const may = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const maydon = may?JSON.parse(may):[]
    const ekin = localStorage.getItem("sfr-hm-"+season+"-ekinlar")
    const ekinlar = ekin?JSON.parse(ekin):{}
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba?JSON.parse(manba):[]
    const gmlars = gmslar(maydon,cropids,true)
    const gmlar = gmlars[0]
    let jami_maydon = gmlars[1];
    return (
        <table className="table table-borderless m-0">
            <thead>
            <tr>
                <td className="text-center">Kanalning FIKI:{
                    manbalar.map((m,i)=>{
                        return <span key={i} className="me-2">{m.name} ({m.fik}){manbalar.length-1!=i?'/':null}</span>
                    })
                }</td>
            </tr>
            <tr>
                <td className="text-center">
                    Gidromodul rayon:
                    {
                        Object.keys(gmlar).map((el,i)=>{
                            return <span key={i} className="ms-2">No:{el.slice(1,)} /</span>
                        })
                    }
                    Umumiy maydon: <b>{jami_maydon}</b> ga
                </td>
            </tr>
            {
                Object.keys(gmlar).map((el,i)=>{
                    return <tr key={i}>
                        <td>
                        <div className="text-center">
                            Gidromodul
                            {el.slice(1,)},
                            jami ga:{Object.values(gmlar[el]).reduce((a,b)=> a+b,0)},
                            ga ({foiz(jami_maydon,Object.values(gmlar[el]).reduce((a,b)=> a+b,0))}%)
                        </div>
                        <div className="mb-2 text-center">{
                            Object.keys(gmlar[el]).map((e,index)=>{
                                return <span key={index} className="ms-2">{ekinlar[e].name}-{gmlar[el][e]} /</span>
                            })
                        }</div>
                        </td>
                    </tr>
                })
            }
            </thead>
        </table>
    );
}

export default Info;